module.exports = __webpack_public_path__ + "img/audi.0e7b13ed.png";